import { render, staticRenderFns } from "./link-details-step.vue?vue&type=template&id=588a47cb"
import script from "./link-details-step.vue?vue&type=script&lang=js"
export * from "./link-details-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports